/**
 * Build query params for GET /tickets/ from search filter state.
 */
export const buildSearchParams = (filters, page = 1, pageSize = 20) => {
  const params = { page, page_size: pageSize };

  if (filters.q?.trim()) {
    params.q = filters.q.trim();
  }
  if (filters.status && filters.status !== "all") {
    params.status = filters.status;
  }
  if (filters.contactReasons?.length) {
    params.contact_reason = filters.contactReasons.join(",");
  }
  if (filters.communicationMethods?.length) {
    params.communication_method = filters.communicationMethods.join(",");
  }
  if (filters.departments?.length) {
    params.departments = filters.departments.join(",");
  }
  if (filters.branches?.length) {
    params.branches = filters.branches.join(",");
  }
  if (filters.products?.length) {
    params.products = filters.products.join(",");
  }
  if (filters.createdFrom) {
    params.created_from = filters.createdFrom;
  }
  if (filters.createdTo) {
    params.created_to = filters.createdTo;
  }
  if (filters.updatedFrom) {
    params.updated_from = filters.updatedFrom;
  }
  if (filters.updatedTo) {
    params.updated_to = filters.updatedTo;
  }
  if (filters.creators?.length) {
    params.creators = filters.creators.join(",");
  }
  if (filters.participants?.length) {
    params.participants = filters.participants.join(",");
  }
  if (filters.complaintClassification?.length) {
    params.complaint_classification = filters.complaintClassification.join(",");
  }

  return params;
};

/** Build query params for reports (filters only, no pagination). */
export const buildFilterParams = (filters) => {
  const params = buildSearchParams(filters, 1, 20);
  delete params.page;
  delete params.page_size;
  return params;
};

export const emptySearchFilters = () => ({
  q: "",
  status: "all",
  contactReasons: [],
  communicationMethods: [],
  departments: [],
  branches: [],
  products: [],
  createdFrom: "",
  createdTo: "",
  updatedFrom: "",
  updatedTo: "",
  creators: [],
  participants: [],
  complaintClassification: [],
});
